const persianDigit = (input: string) => {
  if (input) {
    return input.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
  } else {
    return "";
  }
};

export default persianDigit;
